module.exports = __webpack_public_path__ + "static/pak-gif-3-ea2c1828bd1cc88fdbcb86cbfb34d176.gif";